import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoajantaelloracab() {



const cardData = {
  keyword: " Pune to Ajanta Ellora Cab ",

"headingDescription": "Pune to Ajanta Ellora Cab service offers a comfortable, reliable, and scenic travel experience for passengers planning a historical trip from Pune to the famous Ajanta and Ellora Caves near Aurangabad. Whether it’s a heritage tour, family trip, or educational visit, our professional drivers and well-maintained vehicles ensure a smooth journey. We provide one-way trips, round trips, and customized travel packages with transparent pricing and no hidden charges. With SRS Pune to Ajanta Ellora Cab, enjoy easy online booking, 24/7 customer support, and a hassle-free journey to UNESCO World Heritage Sites.",
"topPlaces": [
  {
    "title": "Ajanta Caves",
    "description": "Ajanta Caves are a UNESCO World Heritage Site known for ancient Buddhist paintings and rock-cut sculptures. Travelers booking Pune to Ajanta Ellora Cab visit this site to explore its artistic and historical significance."
  },
  {
    "title": "Ellora Caves",
    "description": "Ellora Caves are famous for their rock-cut temples representing Hindu, Buddhist, and Jain traditions. Visitors using Pune to Ajanta Ellora Cab admire the architectural brilliance of these caves."
  },
  {
    "title": "Kailasa Temple",
    "description": "Kailasa Temple, part of Ellora, is one of the largest monolithic rock-cut temples in the world. Travelers using Pune to Ajanta Ellora Cab explore this marvel carved from a single rock."
  },
  {
    "title": "Bibi Ka Maqbara",
    "description": "Bibi Ka Maqbara is a Mughal-era monument resembling the Taj Mahal. Visitors traveling via Pune to Ajanta Ellora Cab visit this site for its architecture and historical charm."
  },
  {
    "title": "Daulatabad Fort",
    "description": "Daulatabad Fort is a massive hill fort known for its strong defense system and history. Travelers using Pune to Ajanta Ellora Cab explore this fort for its strategic design and scenic views."
  },
  {
    "title": "Grishneshwar Temple",
    "description": "Grishneshwar Temple is one of the 12 Jyotirlingas dedicated to Lord Shiva, located near Ellora. Devotees booking Pune to Ajanta Ellora Cab often visit this temple for spiritual blessings."
  },
  {
    "title": "Panchakki",
    "description": "Panchakki is an ancient water mill showcasing medieval engineering. Visitors using Pune to Ajanta Ellora Cab explore this site for its unique mechanism and peaceful surroundings."
  },
  {
    "title": "Aurangabad Caves",
    "description": "Aurangabad Caves are lesser-known rock-cut caves with beautiful carvings and sculptures. Travelers using Pune to Ajanta Ellora Cab visit this site for a quieter historical experience."
  },
  {
    "title": "Salim Ali Lake",
    "description": "Salim Ali Lake is a serene spot known for birdwatching and greenery. Visitors booking Pune to Ajanta Ellora Cab relax here and enjoy nature after sightseeing."
  },
  {
    "title": "Siddharth Garden and Zoo",
    "description": "Siddharth Garden and Zoo is a popular family attraction in Aurangabad. Travelers using Pune to Ajanta Ellora Cab visit this place for relaxation and recreation."
  }
],



services: [
{
name: "Ajanta Ellora Caves Tour Package from Pune",
description: "Ajanta Ellora caves tour package from Pune offers complete travel solutions for heritage trips. Customers can explore both UNESCO sites comfortably. Professional drivers ensure safe long-distance travel. Comfortable vehicles enhance journey experience. Flexible multi-day packages are available. Travel easily with Ajanta Ellora tour packages from Pune."
},
{
name: "Ajanta Ellora Tour from Pimpri Chinchwad",
description: "Ajanta Ellora tour from Pimpri Chinchwad provides convenient travel options for nearby travelers. Customers can book cabs for full sightseeing trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Flexible booking options are available. Travel easily from Pimpri Chinchwad to Ajanta Ellora."
},
{
name: "Trip to Ajanta Ellora Caves from Pune",
description: "Trip to Ajanta Ellora caves from Pune offers memorable travel for history lovers. Customers can visit ancient caves with comfortable vehicles. Professional drivers ensure safe journeys. Scenic routes enhance travel experience. Flexible packages are available. Plan your Pune to Ajanta Ellora trip easily."
},
{
name: "Pune to Ajanta Ellora Cab Service",
description: "Pune to Ajanta Ellora cab service provides reliable transportation for long-distance travel. Customers can book cabs for one-way or round trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel comfort. Flexible booking options are available. Travel easily with cab services from Pune."
},
{
name: "Pune to Ajanta Ellora Cab Booking",
description: "Pune to Ajanta Ellora cab booking offers quick and easy reservation options. Customers can book cabs online or via mobile apps. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily from Pune."
},
{
name: "Pune to Ajanta Ellora Cab Fare",
description: "Pune to Ajanta Ellora cab fare provides clear pricing for travel planning. Customers can check fare estimates before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel confidently with cab fare services."
},
{
name: "Pune to Ajanta Verul Cab Fare",
description: "Pune to Ajanta Verul cab fare offers pricing for visiting Ajanta and Ellora caves. Customers can compare fares before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with cab fare services."
},
{
name: "Pune to Ajanta Ellora Innova Cab Fare",
description: "Pune to Ajanta Ellora Innova cab fare offers premium SUV pricing for long trips. Customers can enjoy spacious seating and comfort. Professional drivers ensure safe journeys. Ideal for family travel. Transparent pricing ensures value for money. Travel comfortably with Innova cab services."
},
{
name: "Pune to Ajanta Ellora Ertiga Cab",
description: "Pune to Ajanta Ellora Ertiga cab offers comfortable 7-seater travel for families. Customers can enjoy smooth long-distance journeys. Professional drivers ensure safe travel. Ideal for group trips. Transparent pricing ensures affordability. Travel easily with Ertiga cabs."
},
{
name: "Pune to Ajanta Ellora Tempo Traveller on Rent",
description: "Pune to Ajanta Ellora tempo traveller on rent offers group travel solutions. Customers can book spacious vehicles for tours. Professional drivers ensure safe journeys. Comfortable seating enhances long travel experience. Flexible booking options are available. Travel together with tempo traveller services."
},
{
name: "Pune to Ajanta Ellora Sedan Cab Service",
description: "Pune to Ajanta Ellora sedan cab service provides economical travel options. Customers can book sedans for budget-friendly journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with sedan cab services."
},
{
name: "Pune to Ajanta Ellora Mini Bus on Rent",
description: "Pune to Ajanta Ellora mini bus on rent offers large group travel options. Customers can book buses for tours and family trips. Professional drivers ensure safe journeys. Comfortable seating enhances travel experience. Flexible booking options are available. Travel easily with mini bus rentals."
},
{
name: "Pune to Ajanta Ellora Taxi Service",
description: "Pune to Ajanta Ellora taxi service provides reliable transportation for heritage tours. Customers can book taxis for flexible travel plans. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with taxi services."
},
{
name: "Pune to Ajanta Ellora Cab Booking",
description: "Pune to Ajanta Ellora cab booking provides easy reservation options for travelers. Customers can book cabs instantly online. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel comfort. Flexible booking options are available. Book your cab easily."
},
{
name: "Pune to Ajanta Ellora Taxi Booking",
description: "Pune to Ajanta Ellora taxi booking offers quick and convenient booking options. Customers can reserve taxis online or offline. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your taxi easily from Pune."
},
{
name: "Pune to Ajanta Ellora One Way Cab",
description: "Pune to Ajanta Ellora one way cab offers economical travel without return charges. Customers can book direct rides easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Transparent pricing ensures affordability. Choose one-way cab services."
},
{
name: "Pune to Ajanta Ellora One Way Taxi",
description: "Pune to Ajanta Ellora one way taxi provides convenient travel for single-direction journeys. Customers can book taxis easily. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one-way taxi services."
},
{
name: "Pune to Ajanta Ellora Taxi Price",
description: "Pune to Ajanta Ellora taxi price provides detailed pricing for travel planning. Customers can compare rates before booking rides. Affordable pricing ensures budget-friendly journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Choose taxi services with transparent pricing."
}
],

tableData: [
["Ajanta Ellora Caves Tour Package from Pune","Ajanta Ellora Tour from Pimpri Chinchwad"],
["Trip to Ajanta Ellora Caves from Pune","Pune to Ajanta Ellora Cab Service"],
["Pune to Ajanta Ellora Cab Booking","Pune to Ajanta Ellora Cab Fare"],
["Pune to Ajanta Verul Cab Fare","Pune to Ajanta Ellora Innova Cab Fare"],
["Pune to Ajanta Ellora Ertiga Cab","Pune to Ajanta Ellora Tempo Traveller on Rent"],
["Pune to Ajanta Ellora Sedan Cab Service","Pune to Ajanta Ellora Mini Bus on Rent"],
["Pune to Ajanta Ellora Taxi Service","Pune to Ajanta Ellora Cab Booking"],
["Pune to Ajanta Ellora Taxi Booking","Pune to Ajanta Ellora One Way Cab"],
["Pune to Ajanta Ellora One Way Taxi","Pune to Ajanta Ellora Taxi Price"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Heritage Route Drivers",
    WhyChoosedescription: "SRS Cab Service provides skilled drivers familiar with Pune to Ajanta Ellora routes, ensuring safe driving and smooth navigation across highways and tourist circuits."
  },
  {
    WhyChooseheading: "Affordable Ajanta Ellora Cab Packages",
    WhyChoosedescription: "We offer budget-friendly Pune to Ajanta Ellora cab services with transparent pricing. Customers receive complete fare details including tolls, parking, and driver charges with no hidden costs."
  },
  {
    WhyChooseheading: "Customized 2-3 Day Travel Plans",
    WhyChoosedescription: "SRS Cab Service provides flexible tour packages for Ajanta and Ellora caves, allowing customers to plan 2-day or 3-day trips comfortably with proper sightseeing coverage."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Pune to Ajanta Ellora cab service operates 24/7, making it convenient for long-distance travel, early morning departures, and multi-day tours."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles for Long Travel",
    WhyChoosedescription: "We provide clean, well-maintained, and air-conditioned vehicles suitable for long-distance journeys, ensuring a relaxing and enjoyable travel experience."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers suitable for families, groups, and tourists."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We offer convenient pickup from homes, hotels, offices, and Pune Airport across all major areas including Hinjewadi, Wakad, Baner, and Hadapsar."
  },
  {
    WhyChooseheading: "Trusted Tourist Cab Service",
    WhyChoosedescription: "SRS Cab Service is trusted for Pune to Ajanta Ellora cab bookings due to reliable service, experienced drivers, and comfortable travel for heritage tours."
  }
]
}

const faqData = [
  { question: "Do you provide Pune to Ajanta Ellora cab service?", answer: "Yes, SRS Cab Service offers reliable cab services from Pune to Ajanta and Ellora caves." },
  { question: "How far are Ajanta Ellora caves from Pune?", answer: "The distance is approximately 450 km and the journey takes around 8 to 10 hours depending on route and traffic." },
  { question: "Is Pune to Ajanta Ellora cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 for flexible travel planning." },
  { question: "How many days are required for Ajanta Ellora trip?", answer: "Typically, a 2 to 3-day trip is recommended to comfortably cover Ajanta and Ellora caves along with nearby attractions." },
  { question: "Which vehicles are available for Ajanta Ellora travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, luxury Innova Crysta, and Tempo Travellers." },
  { question: "Can I customize my Ajanta Ellora tour?", answer: "Yes, we provide customized travel plans based on your itinerary and travel duration." },
  { question: "Are vehicles suitable for long-distance travel?", answer: "Yes, all vehicles are well-maintained and suitable for long-distance journeys." },
  { question: "Can I book the cab online?", answer: "Yes, you can easily book Pune to Ajanta Ellora cab service online or via phone." },
  { question: "Do you provide pickup from Pune home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, offices, and Pune Airport." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sunil Patil",
    feedback:
      "Booked SRS Cab Service for Ajanta Ellora trip. Very comfortable journey and driver was very knowledgeable.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Kavita Sharma",
    feedback:
      "Excellent Pune to Ajanta Ellora cab service. Smooth trip and perfect planning for sightseeing.",
    rating: 5
  }
];
































const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ajanta Ellora Cab | SRS Cab",
  "description": "SRS Cab provides Pune to Ajanta Ellora cab services and tour packages including one-way and round trips, Innova and Ertiga cabs, tempo travellers, sedans, and mini buses on rent. Book safe, comfortable, and affordable rides from Pune to Ajanta Ellora caves for sightseeing and tours with 24x7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};






  return (
    <div>
      <Helmet>
  <title>Pune to Ajanta Ellora Cab | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book Pune to Ajanta Ellora cabs with SRS Cab. One-way, round trips, Innova, Ertiga, tempo travellers, sedans, and mini buses for sightseeing and tours. Safe, comfortable, and affordable rides with 24x7 online booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>




 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/21.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoajantaelloracab;